var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMyob(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 96 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M15.738 11.459c-1.48-1.776-3.733-2.882-6.524-2.882C3.632 8.544 0 12.497 0 17.657v11.828h1.715c1.177-.067 3.464-.637 3.53-4.021v-7.907c0-2.312 1.615-3.887 3.969-3.887 3.463 0 3.833 2.748 3.833 3.887v11.928h1.715c1.144-.067 3.43-.637 3.531-3.988v-7.94c0-2.312 1.682-3.887 3.968-3.887 3.464 0 3.867 2.748 3.867 3.887v11.928h1.715c1.177-.067 3.498-.637 3.531-4.088v-7.74c0-5.36-3.396-9.113-9.113-9.113-2.656 0-4.977 1.139-6.523 2.915Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M46.507 11.325 42.1 23.52l-4.808-12.632c-.74-2.01-2.623-1.876-2.623-1.876h-4.103l8.138 19.835c0-.034 0-.034-.034-.067 0 0 0 .033.034.067 0 .034.034.067.034.067l-.034-.1c.269.804.202 1.24-.067 2.043l-.168.503c-.942 2.345-2.287 2.982-5.112 2.814v.034L35.308 39c3.632-.067 6.39-1.273 8.206-5.796l9.785-24.191h-3.665c-.168 0-2.253.067-3.127 2.312Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M57.2 19.332c0-3.518 2.253-5.997 5.044-5.997 2.791 0 5.044 2.446 5.044 5.997 0 3.451-2.253 5.83-5.044 5.83-2.791 0-5.044-2.378-5.044-5.83Zm-5.246-.033c0 6.098 4.607 10.655 10.29 10.655 5.683 0 10.324-4.557 10.324-10.655 0-6.098-4.64-10.722-10.324-10.722-5.683-.033-10.29 4.624-10.29 10.722Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M79.562 19.332c0-3.25 2.354-5.863 5.246-5.863 2.892 0 5.246 2.546 5.246 5.864 0 3.25-2.354 5.729-5.246 5.729-2.892.033-5.246-2.547-5.246-5.73ZM78.486 0c-3.564 0-4.136 2.412-4.203 3.552v25.933h2.522c2.017.033 2.488-1.24 2.522-1.977v-.201c1.58 1.675 3.766 2.613 6.254 2.613 5.38 0 9.752-4.59 9.752-10.621 0-6.064-4.371-10.655-9.752-10.655-2.353 0-4.438.871-6.019 2.38V0h-1.076Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    x2: 95.321,
    y1: 19.503,
    y2: 19.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 95.321,
    y1: 19.503,
    y2: 19.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    x2: 95.321,
    y1: 19.503,
    y2: 19.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    x2: 95.321,
    y1: 19.503,
    y2: 19.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#6100A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#7001A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#980293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895,
    stopColor: "#D9057E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#ED0677"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMyob);
export default __webpack_public_path__ + "static/media/logo-myob.2e35b23956de565e8af9e6cb50f0a93c.svg";
export { ForwardRef as ReactComponent };